import { useEffect } from 'react';

const LEGACY_PATH = /\/countsApproval\/?$/i;

/**
 * Legacy /countsApproval list: now the Waiting for approval group of Stock counts.
 * The route stays (host menus link here); it only redirects.
 */
const CountApproval = () => {
  useEffect(() => {
    // Already redirected (e.g. a StrictMode re-run of this effect).
    if (!LEGACY_PATH.test(location.pathname)) return;
    const target = `${location.pathname.replace(LEGACY_PATH, '/stockCounts')}?status=waiting`;
    // Replace this entry and let the host router re-read it: Back skips the redirect.
    window.history.replaceState(window.history.state, '', target);
    window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
  }, []);

  return null;
};

export default CountApproval;
